import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router';
import { translate } from 'react-i18next';
import Table from 'antd/lib/table';
import { t } from '../../../app/i18n';
import { ResponsiveTable } from '../../../common/components/data-display';
import { Modal } from 'antd';
import { formatDate } from '../../../common/utils/helpers';
import { messageStatus, messageStatusT } from '../../../common/enums'
import { Button } from 'antd/lib/radio';
import Form from 'antd/lib/form';
import Input from 'antd/lib/input';
import { DatePicker } from 'antd';
import moment from 'moment';
import { addHolidayAction, deleteHolidayAction } from '../ducks'
import connect from 'react-redux/lib/connect/connect';
import { bindActionCreators } from 'redux';

const HolidayNamesTranslation = {
  "Republic Day": "Deň vzniku SR",
  "Epiphany": "Zjavenie Pána (Traja králi)",
  "Good Friday": "Veľký piatok",
  "Easter Monday": "Veľkonočný pondelok",
  "Labor Day": "Sviatok práce",
  "End of World War II": "Deň víťazstva nad fašizmom",
  "St. Cyril & St. Methodius Day": "Sviatok svätého Cyrila a Metoda",
  "National Uprising Day": "Výročie SNP",
  "Constitution Day": "Deň ústavy SR",
  "Day of Our Lady of Sorrows": "Sedembolestná Panna Mária",
  "All Saints' Day": "Sviatok všetkých svätých",
  "Fight for Freedom and Democracy Day": "Deň boja za slobodu a demokraciu",
  "Christmas Eve": "Štedrý deň",
  "Christmas Day": "Prvý sviatok vianočný",
  "St. Stephen's Day": "Druhý sviatok vianočný"
}
const Column = Table.Column;



const mapDispatchToProps = dispatch => ({
  actions: bindActionCreators(
    {
      addHoliday: addHolidayAction.request,
      deleteHoliday: deleteHolidayAction.request
    },
    dispatch
  ),
});



const dateFunction = (date) => {
  return {
    children: <span>{date ? `${formatDate(date)}` : ``}</span>,
  };
};
const nameFunction = (name) => {
  return {
    children: <span>{`${HolidayNamesTranslation[name] || name}`}</span>,
  };
};


@connect(null, mapDispatchToProps)
export default class HolidaysTable extends Component {
  static propTypes = {
    holidays: PropTypes.array.isRequired,
    loading: PropTypes.bool.isRequired,
    onChange: PropTypes.func.isRequired,
    pagination: PropTypes.object.isRequired,
    t: PropTypes.func.isRequired,
    actions: PropTypes.object,

  };

  constructor() {
    super();
    this.state = {
      isModalVisible: false,
      newHolidayName: '',
      newHolidayDate: moment(),
      nameWarningVisible: false,
      dateWarningVisible: false
    };
  }

  actionFunction = (id) => {
    const { actions } = this.props

    return {
      children: (
        <span>
          <Link onClick={() => actions.deleteHoliday(id)}>{t('Vymazať')}</Link>
        </span>
      ),
    };
  };

  handleOk = () => {

    const { actions } = this.props
    const name = this.state.newHolidayName
    const date = this.state.newHolidayDate

    if (name && date) {
      actions.addHoliday({ name: this.state.newHolidayName, date: this.state.newHolidayDate })

      this.setState({
        newHolidayName: "",
        newHolidayDate: moment(Date.now()),
        isModalVisible: false,
        nameWarningVisible: false,
        dateWarningVisible: false
      })

    } else {
      this.setState({
        nameWarningVisible: name.length == 0,
        dateWarningVisible: date == null
      })

    }

  };

  handleCancel = () => {
    this.setState({
      newHolidayName: "",
      newHolidayDate: moment(Date.now()),
      isModalVisible: false,
      nameWarningVisible: false,
      dateWarningVisible: false
    })
  };

  render() {
    const {
      holidays,
      loading,
      onChange,
      pagination, t
    } = this.props;



    return (
      <div>
        <Button onClick={() => this.setState({ isModalVisible: true })}>{t("Pridať voľný deň")}</Button>

        <ResponsiveTable
          dataSource={holidays}
          loading={loading}
          onChange={onChange}
          pagination={pagination}
          rowKey={holiday => holiday.id}
          rowClassName={holiday => holiday.nonpayer ? 'nonpayer-row' : ''}
        >
          <Column
            title={t('Názov')}
            dataIndex="name"
            key="name"
            render={(item) => nameFunction(item)}
          />
          <Column
            title={t('Dátum')}
            dataIndex="date"
            key="date"
            render={(item) => dateFunction(item)}
          />
          <Column
            title={t('Akcie')}
            dataIndex="id"

            key="action"
            render={(item) => this.actionFunction(item)}
          />
        </ResponsiveTable>
        <Modal title={t("Pridať voľný deň")} visible={this.state.isModalVisible} onOk={this.handleOk} onCancel={this.handleCancel}>
          <div>
            <Form>
              <Form.Item label={t('Názov')}>
                < Input
                  value={this.state.newHolidayName}
                  onChange={e => this.setState({ newHolidayName: e.target.value })}>
                </Input>
                <p style={{ visibility: this.state.nameWarningVisible ? 'visible' : 'hidden', color: "red" }}>{t("Prosím zadajte názov")}</p>
              </Form.Item>

              <Form.Item label={t('Dátum')}>
                <DatePicker
                  allowClear={false}
                  showToday={true}
                  value={this.state.newHolidayDate}
                  format={'DD.MM.YYYY'}
                  onChange={e => this.setState({ newHolidayDate: e })}

                />
                <p style={{ visibility: this.state.dateWarningVisible ? 'visible' : 'hidden', color: "red" }}>{t("Prosím vyberte dátum")}</p>

              </Form.Item>
            </Form>
          </div>
        </Modal>
      </div >
    )
  };

}



// WEBPACK FOOTER //
// ./src/features/messaging-dashboard/components/HolidaysTable.js